import {useSelector} from "react-redux";
import {css, Theme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {Col} from "@pg-design/grid-module";
import {borderRadius, calculateRemSize, mb, mr, mt, ph, pv} from "@pg-design/helpers-css";
import {BrandFlagIcon} from "@pg-design/icons-module";
import {Link} from "@pg-design/link-module";
import {Text} from "@pg-design/text-module";
import {FormikForm} from "@pg-mono/formik-utils";
import {rpAppLink} from "@pg-mono/rp-routes";

import {IRPStore} from "../../../app/rp_reducer";
import {RodoFormInfo} from "../../../application/components/RodoFormInfo";

interface IProps {
    criteria: string;
    handleCriteriaButtonClick: () => void;
}
export const OfferListSummaryView = (props: IProps) => {
    const codes = useSelector((store: IRPStore) => store.variables.data?.country_codes);

    return (
        <div css={summaryWrapper}>
            <div css={grayBorderBox}>
                <Text css={criteriaWrapperStyle}>{props.criteria}</Text>
                <Button variant="none_secondary" onClick={props.handleCriteriaButtonClick}>{`${props.criteria ? "Zmień" : "Dodaj"} kryteria`}</Button>
            </div>
            <div css={formWrapper}>
                <FormikForm.Input name="email" type="email" css={mb(2)} placeholder="e-mail" />
                <FormikForm.PhoneField codes={codes ?? []} name="phone" css={mb(2)} placeholder="Telefon" />
                <FormikForm.Checkbox
                    name="general_marketing_consent"
                    checkedMarkColor="#02D054"
                    id="general_marketing_consent"
                    labelContent={
                        <Text variant="info_txt_1" as="span">
                            Chcę otrzymywać mailem lub SMSem linki do nowych ofert nieruchomości. Zgodę mogę zawsze odwołać.
                        </Text>
                    }
                />
                <Button size="medium" variant="filled_primary" type="submit">
                    Włącz
                </Button>
                <RodoFormInfo />
                <Text align="center" css={termsLink} variant="info_txt_2">
                    Akceptuję{" "}
                    <Link size="small" underline href={rpAppLink.termsOfService.base()} target="_blank">
                        regulamin serwisu
                    </Link>
                </Text>
            </div>
        </div>
    );
};

export const SummaryHeader = () => {
    return (
        <div css={headerWrapper}>
            <div css={flagIconContainer}>
                <BrandFlagIcon size="4" />
            </div>
            <Col css={titleContainer}>
                <Text variant="headline_4" css={mb(2)}>
                    Bądź na bieżąco
                </Text>
                <Text variant="body_copy_1" css={headingSubtitle}>
                    Zapisz się na powiadomienia i otrzymuj nowe oferty zgodne z Twoimi preferencjami
                </Text>
            </Col>
        </div>
    );
};

const flagIconContainer = (theme: Theme) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    height: ${calculateRemSize(8)};
    width: ${calculateRemSize(8)};
    background-color: ${theme.colors.primary};
    border-radius: 50%;
    ${mr(1.5)};
`;

const headingSubtitle = (theme: Theme) => css`
    max-width: 504px;
    color: ${theme.colors.gray[800]};
`;

const titleContainer = css`
    max-width: 504px;
`;

const grayBorderBox = (theme: Theme) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-height: 158px;
    min-height: 108px;
    border: 1px solid ${theme.colors.gray[500]};
    ${pv(2)};
    ${ph(1)};
    ${borderRadius(1)};

    p {
        text-align: center;
    }
`;
const termsLink = (theme: Theme) => css`
    margin-top: -${calculateRemSize(1)};
    &,
    & * {
        color: ${theme.colors.gray[700]} !important;
    }
`;

const headerWrapper = () => css`
    display: flex;
    align-items: flex-start;
    ${mb(3)};
`;

const summaryWrapper = css`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: ${calculateRemSize(3)};
`;

const formWrapper = css`
    display: flex;
    flex-direction: column;
    width: 100%;
    > button {
        ${mt(3)};
        width: 100%;
    }
`;

const criteriaWrapperStyle = css`
    overflow: auto;
    max-height: 100%;
    display: flex;
`;
import {useSelector} from "react-redux";
import {css, Theme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {Col} from "@pg-design/grid-module";
import {borderRadius, calculateRemSize, mb, mr, mt, ph, pv} from "@pg-design/helpers-css";
import {BrandFlagIcon} from "@pg-design/icons-module";
import {Link} from "@pg-design/link-module";
import {Text} from "@pg-design/text-module";
import {FormikForm} from "@pg-mono/formik-utils";
import {rpAppLink} from "@pg-mono/rp-routes";

import {IRPStore} from "../../../app/rp_reducer";
import {RodoFormInfo} from "../../../application/components/RodoFormInfo";

interface IProps {
    criteria: string;
    handleCriteriaButtonClick: () => void;
}
export const OfferListSummaryView = (props: IProps) => {
    const codes = useSelector((store: IRPStore) => store.variables.data?.country_codes);

    return (
        <div css={summaryWrapper}>
            <div css={grayBorderBox}>
                <Text css={criteriaWrapperStyle}>{props.criteria}</Text>
                <Button variant="none_secondary" onClick={props.handleCriteriaButtonClick}>{`${props.criteria ? "Zmień" : "Dodaj"} kryteria`}</Button>
            </div>
            <div css={formWrapper}>
                <FormikForm.Input name="email" type="email" css={mb(2)} placeholder="e-mail" />
                <FormikForm.PhoneField codes={codes ?? []} name="phone" css={mb(2)} placeholder="Telefon" />
                <FormikForm.Checkbox
                    name="general_marketing_consent"
                    checkedMarkColor="#02D054"
                    id="general_marketing_consent"
                    labelContent={
                        <Text variant="info_txt_1" as="span">
                            Chcę otrzymywać mailem lub SMSem linki do nowych ofert nieruchomości. Zgodę mogę zawsze odwołać.
                        </Text>
                    }
                />
                <Button size="medium" variant="filled_primary" type="submit">
                    Włącz
                </Button>
                <RodoFormInfo />
                <Text align="center" css={termsLink} variant="info_txt_2">
                    Akceptuję{" "}
                    <Link size="small" underline href={rpAppLink.termsOfService.base()} target="_blank">
                        regulamin serwisu
                    </Link>
                </Text>
            </div>
        </div>
    );
};

export const SummaryHeader = () => {
    return (
        <div css={headerWrapper}>
            <div css={flagIconContainer}>
                <BrandFlagIcon size="4" />
            </div>
            <Col css={titleContainer}>
                <Text variant="headline_4" css={mb(2)}>
                    Bądź na bieżąco
                </Text>
                <Text variant="body_copy_1" css={headingSubtitle}>
                    Zapisz się na powiadomienia i otrzymuj nowe oferty zgodne z Twoimi preferencjami
                </Text>
            </Col>
        </div>
    );
};

const flagIconContainer = (theme: Theme) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    height: ${calculateRemSize(8)};
    width: ${calculateRemSize(8)};
    background-color: ${theme.colors.primary};
    border-radius: 50%;
    ${mr(1.5)};
`;

const headingSubtitle = (theme: Theme) => css`
    max-width: 504px;
    color: ${theme.colors.gray[800]};
`;

const titleContainer = css`
    max-width: 504px;
`;

const grayBorderBox = (theme: Theme) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-height: 158px;
    min-height: 108px;
    border: 1px solid ${theme.colors.gray[500]};
    ${pv(2)};
    ${ph(1)};
    ${borderRadius(1)};

    p {
        text-align: center;
    }
`;
const termsLink = (theme: Theme) => css`
    margin-top: -${calculateRemSize(1)};
    &,
    & * {
        color: ${theme.colors.gray[700]} !important;
    }
`;

const headerWrapper = () => css`
    display: flex;
    align-items: flex-start;
    ${mb(3)};
`;

const summaryWrapper = css`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: ${calculateRemSize(3)};
`;

const formWrapper = css`
    display: flex;
    flex-direction: column;
    width: 100%;
    > button {
        ${mt(3)};
        width: 100%;
    }
`;

const criteriaWrapperStyle = css`
    overflow: auto;
    max-height: 100%;
    display: flex;
`;
